module.exports = __webpack_public_path__ + "static/img/20001 (1).7842276.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20001 (1).webp
// module id = ZhkA
// module chunks = 14